<template>
  <div class="cmi-container">
    <cmi></cmi>
  </div>
</template>

<script>
import cmi from "./components/cmi.vue"
export default {
  components: {
    cmi
  }
}
</script>

<style>
.cmi-container {
  height: 100%;
  font-weight: 400;
}
</style>
